import type { Order, Language } from "../../../../../../../services";

const cellProcessing = (
	item: Order.Model["orderToCarClasses"],
	language: Language,
): string => item?.map((it) => it?.carClass?.name?.[language]).join(", ") ?? "";

export default cellProcessing;
